export const LOCALSTORAGE_CONST = {
  ADD_HORSE_FROM: 'ADD_HORSE_FROM',
  EDIT_EVENT_TAB_TO_OPEN: 'EDIT_EVENT_TAB_TO_OPEN',
}
